import axiosInstance from "./axiosInstance";
import { formatRequest } from "../utils/function";

//customer serach
export function getAllCustomerSerachStoreOwner(data) {
  return axiosInstance.post(`/customer-search`, formatRequest(data));
}
export function getAllCustomerSerachStoreWiseList(data) {
  return axiosInstance.post(`/customer-store-search`, formatRequest(data));
}

//create customer
export function createCustomerSerachStoreOwner(data) {
  return axiosInstance.post(`/create-customer`, formatRequest(data));
}

//order create
export function createOrderStoreOwner(data) {
  return axiosInstance.post(`/order-create`, formatRequest(data));
}

//store dashboard
export function getStoreDashboardDetails(data) {
  return axiosInstance.post(`/store-dashboard`, formatRequest(data));
}

//update order payment
export function updateOrderPayment(data) {
  return axiosInstance.post(`/update-order-payment`, formatRequest(data));
}

//order list
export function getStoreOwnerOrderList(data) {
  return axiosInstance.post(`/order-list`, formatRequest(data));
}

//order details
export function getStoreOwnerOrderDetails(data) {
  return axiosInstance.post(`/order-details`, formatRequest(data));
}

//pending order
export function getStoreCustomerPendingOrder(data) {
  return axiosInstance.post(
    `/store-customer-pending-order`,
    formatRequest(data),
  );
}

//daily collection
export function getDailyCollection(data) {
  return axiosInstance.post(`/daily-collection`, formatRequest(data));
}

//order status
export function updateOrderStatus(data) {
  return axiosInstance.post(`/update-order-status`, formatRequest(data));
}

//Customer Ledger
export function createCustomerLedger(data) {
  return axiosInstance.post(`/save-customer-ledger`, formatRequest(data));
}

//Customer Ledger details
export function getCustomerLedgerDetails(data) {
  return axiosInstance.post(`/customer-ledge-list`, formatRequest(data));
}

export function exportCustomerLedgerCSV(data) {
  return axiosInstance.post(`/customer-ledger/export-csv`, formatRequest(data));
}

export function exportCustomerLedgerPDF(data) {
  return axiosInstance.post(`/customer-ledger/export-pdf`, formatRequest(data));
}

export function getCustomerLedgerReportList(data) {
  return axiosInstance.post(`/customer-ledger/report-list`, formatRequest(data));
}

export function createCustomerLedgerPendingPayment(data) {
  return axiosInstance.post(`/customer-ledger/pending-payment`, formatRequest(data));
}

export function createCustomerStore(data) {
  return axiosInstance.post(`/create-customer-store`, formatRequest(data));
}

export function deleteCustomerStore(data) {
  return axiosInstance.post(`/delete-customer-store`, formatRequest(data));
}

export function getCustomerStoreMasterList(data) {
  return axiosInstance.post(`/customer-store-list`, formatRequest(data));
}










